module.exports = __webpack_public_path__ + "static/media/rb_china.58b42275.png";